import { DropCourseSectionsCommand } from '../../course_scheduler/commands/drop_course_sections_command';
import { IPreventTransientAccessQueryResult } from '../../../prevent_transient_access/queries/prevent_transient_access_query';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISection, IMenuAction } from '../../../interfaces/scheduler_interfaces';
import { TermCourseServant } from '../../term_courses/servants/term_course_servant';
import { ITermSessionsDatasource } from '../../term_courses/datasources/term_sessions_datasource';
import { SectionTileMenuEnum } from '../../course_scheduler/types/section_tile_menu_enum';
import { IRegisterSectionsDatasource } from '../../course_scheduler/datasources/register_sections_datasource';
import { ScheduledSectionServant } from '../../course_scheduler/servants/scheduled_section_servant';
import { ScheduledSectionStatusServant } from '../../course_scheduler/servants/scheduled_section_status_servant';
import { CrossCourseLinkedSectionServant } from '../../course_scheduler/servants/cross_course_linked_section_servant';
import { ScheduledSectionsQuery } from '../../course_scheduler/queries/scheduled_sections_query';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { ScheduledSectionStatus } from '../../course_scheduler/types/scheduled_section_status_enum';
import { MultiSectionServant } from '../../course_scheduler/servants/multi_section_servant';
import { AllSectionsQuery } from '../../course_scheduler/queries/all_sections_query';
import { ScheduledSectionRequestStateCommand } from '../../../request_state/commands/scheduled_section_request_state_command';

export class DropCourseFacade {
  constructor(
    private unscheduleCourseSectionsCommand: ICommand,
    private dropCourseSectionsCommand: DropCourseSectionsCommand,
    private ngTermCourseServant: TermCourseServant,
    private $state: ng.ui.IStateService,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngMultiSectionServant: MultiSectionServant,
    private $stateParams: ng.ui.IStateParamsService,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngTermSessionsDatasource: ITermSessionsDatasource,
    private $q: ng.IQService,
    private ngAllSectionsQuery: AllSectionsQuery,
    private ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngCrossCourseLinkedSectionServant: CrossCourseLinkedSectionServant,
    private scheduledSectionRequestStateCommand: ScheduledSectionRequestStateCommand
  ) {}

  // TODO: Migrated from course_tile_menu component
  // Code needs refactor to reduce complexity
  dropCourseAndCoreqs(
    section: ISection,
    action: IMenuAction,
    sectionPins: Record<string, number>,
    student_credentials?: IPreventTransientAccessQueryResult['output']
  ) {
    const deffered = this.$q.defer();

    let courseCoreqLinkedSections: number[] = [];

    const registeredEnforcedCoreqs = this.ngScheduledSectionServant.getRegisteredCoreqsRelated(
      section,
      this.ngAllSectionsQuery.result
    );

    // If dropping a course coreq, also drop linked sections as well
    _4.each(registeredEnforcedCoreqs, (coreq: ISection) => {
      const sectionCoreqs = this.ngCrossCourseLinkedSectionServant.getSectionIdOfLinkedCrossCourses(
        coreq.id,
        this.ngScheduledSectionsQuery.result.list
      );
      courseCoreqLinkedSections = _4.uniq(_4.concat(courseCoreqLinkedSections, sectionCoreqs));
    });

    const hasEnforcedRegisteredInProgressCoreqsRelated =
      this.ngScheduledSectionStatusServant.isCoreqEnforcementEnabled() && _4.size(registeredEnforcedCoreqs) > 0;

    // Check if has linked sections
    let crossCourseLinkedSectionIds = this.ngCrossCourseLinkedSectionServant.getSectionIdOfLinkedCrossCourses(
      section.id,
      this.ngScheduledSectionsQuery.result.list
    );

    crossCourseLinkedSectionIds = _4.uniq(_4.concat(crossCourseLinkedSectionIds, courseCoreqLinkedSections));

    const registeredInProgressLinkedSections = _4.filter(
      this.ngCrossCourseLinkedSectionServant.getSectionsByIds(
        crossCourseLinkedSectionIds,
        this.ngSectionsDatasource.metasource().derived()
      ),
      (coreqSection: ISection) =>
        this.ngScheduledSectionServant.isSectionRegistered(coreqSection) ||
        this.ngScheduledSectionServant.isSectionInProgress(coreqSection)
    );

    const isMultiSectionCourse = TermCourseServant.isMultiSectionCourse(section._course);
    const hasSessions = !_4.isEmpty(this.ngTermSessionsDatasource.read());
    const shouldDropSpecificSection =
      hasSessions &&
      !isMultiSectionCourse &&
      _4.isEmpty(crossCourseLinkedSectionIds) &&
      _4.isEmpty(registeredEnforcedCoreqs);
    if (action.id === SectionTileMenuEnum.UNSCHEDULE_SECTIONS) {
      this.unscheduleCourseSectionsCommand(
        this.$stateParams.termId,
        section._course.id,
        _4.get(section._section_type, 'session', -1)
      ).then(() => {
        this.resetStateandUpdateSectionAvailabilities();
      });
    } else {
      // NOTE: All other actions call dropCourseSectionsCommand
      // DROP_SECTIONS, DROP_COURSE, REMOVE_WAITLIST
      const isWaitlistedSection = action.id === SectionTileMenuEnum.REMOVE_WAITLIST; // isWaitlist
      let courseIdsToDrop = [section._course.id];
      let sectionIdsToDrop: number[] = [];
      const courseIdsOfLinkedSections = _4.uniq(_4.map(registeredInProgressLinkedSections, (sctn) => sctn.course));

      if (courseIdsOfLinkedSections.length > 0) {
        courseIdsToDrop = _4.concat(courseIdsToDrop, courseIdsOfLinkedSections);
      }

      if (hasEnforcedRegisteredInProgressCoreqsRelated) {
        const registeredInProgressCoreqsRelatedIds: number[] = _4.map(registeredEnforcedCoreqs, 'course');
        courseIdsToDrop = _4.concat(courseIdsToDrop, registeredInProgressCoreqsRelatedIds, [section._course.id]);
        sectionIdsToDrop = _4.map(registeredEnforcedCoreqs, 'id');
      }

      if (!_4.isEmpty(registeredInProgressLinkedSections)) {
        sectionIdsToDrop = _4.map(registeredInProgressLinkedSections, 'id');
      }
      if (isMultiSectionCourse) {
        sectionIdsToDrop = _4.concat(
          sectionIdsToDrop,
          _4.map(this.ngMultiSectionServant.getScheduledSiblingSections(section), 'id')
        );
      }
      const sectionIds = shouldDropSpecificSection ? [section.id] : _4.concat([section.id], sectionIdsToDrop);
      this.scheduledSectionRequestStateCommand(sectionIds, true).then(() => {
        this.dropCourseSectionsCommand(
          this.$stateParams.termId,
          _4.uniq(courseIdsToDrop),
          isWaitlistedSection,
          _4.get(section._section_type, 'session', -1),
          sectionPins,
          _4.uniq(sectionIds),
          student_credentials
        ).then(() => {
          this.resetStateandUpdateSectionAvailabilities();
          deffered.resolve();
        });
      });
    }
    return deffered.promise;
  }

  resetStateandUpdateSectionAvailabilities() {
    if (this.$state.is('my.schedule.registration.courseSections')) {
      this.$state.go('^');
    }
  }
}
angular.module('capability-ng-scheduler').service('ngDropCourseFacade', DropCourseFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/drop_course_facade.ts